import React, { useEffect } from "react";
import { connect } from "react-redux";
import useGetMovies from "../custom-hooks/useGetMovies";
import Latest from "../components/Latest";
import Text from "../components/Text";
import Carousel from "./Carousel";
import { nowPlaying } from "../constants";
import { settings } from "../constants/slider";

import "../assets/styles/components/MovieList.scss";

import Movie from "./Movie";
import Error from "./Error";
import Loader from "./Loader";

const NowPlaying = (props) => {
  const { movies, loading, error, getMovies } = useGetMovies(`${nowPlaying()}`);

  useEffect(() => {
    getMovies();
  }, []);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : error ? (
        <Error />
      ) : (
        <>
          <div className="container-latest">
            <Latest />
          </div>
          <Text text="Now Playing" />
          <Carousel settings={settings}>
            {movies.map((movie) => (
              <Movie key={movie.id} data={movie} config={settings} />
            ))}
          </Carousel>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    popularMovies: state.popularMovies,
  };
};

export default connect(mapStateToProps, null)(NowPlaying);
